'use client'

import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import '../style.css'

const ReactQuill = dynamic(() => import('react-quill'), { ssr: false })
import 'react-quill/dist/quill.snow.css'
import { Button, Modal } from 'flowbite-react'

const EditFullScreen = (
  {
    modules,
    isOpen,
    setOpenModal,
    defaultValue,
    onUpdateValue,
    onUpdateTitle,
    summary,
    title,
    hasCustomField,
    customFieldName = '',
    customFieldDescription = '',
    customeFieldTitle
  }: {
    modules: any,
    isOpen: boolean,
    setOpenModal: any
    defaultValue: string
    onUpdateValue: any
    onUpdateTitle?: (value: string) => void
    summary?: string
    title?: string
    hasCustomField?: boolean
    customFieldName?: string
    customFieldDescription?: string
    customeFieldTitle?: string
  },
) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  function closeModal() {
    onUpdateValue(value)
    setOpenModal(false)
  }

  function onCancel() {
    setValue(defaultValue)
    setOpenModal(false)
  }

  return (
    <Modal show={isOpen} onClose={() => setOpenModal(false)}>
      <Modal.Body>
        <div className="space-y-6">
          <div className="space-y-1">
            <div className="text-gray-900 text-2xl font-bold leading-9">
              Edit {title}
            </div>
            <div className="text-gray-900 text-sm">{summary}</div>
          </div>
          <div className="editor-h-full">
            {
              hasCustomField &&
              <div className="mb-8">
                <label htmlFor={customFieldName}
                       className="text-sm font-medium block text-gray-900 dark:text-white">
                  {title + customFieldName}
                </label>
                {customFieldDescription && (
                  <span
                    className="text-sm text-gray-500 mb-2">{customFieldDescription}</span>
                )}
                <input
                  defaultValue={customeFieldTitle}
                  onChange={(e) => {
                    onUpdateTitle && onUpdateTitle(e.target.value)
                  }}
                  type="text"
                  id={customFieldName}
                  className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required />
              </div>
            }
            <ReactQuill theme="snow"
                        modules={modules}
                        value={value}
                        placeholder="Write text here ..."
                        onChange={setValue} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-end items-center gap-3">
          <Button color="gray" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="dark" onClick={closeModal}>
            Update
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default EditFullScreen
